const mapping: Record<string, string> = {
  id: 'l=>l.Id',
  name: 'p=>p.Name',
}

export const mapSortContainerParam = (key: string) => mapping[key]
